export const Bolt = () => {
    return (
        <svg fill="currentColor" aria-hidden="true" viewBox="0 0 44 65">
            <path d="M26.866 1.129c1.15-1.562 3.624-.556 3.357 1.365l-5.216 37.56H1.91c-1.533 0-2.414-1.743-1.506-2.977L26.866 1.129Z" />
            <path d="M41.456 24.668c1.533 0 2.414 1.743 1.506 2.977L16.5 63.594c-1.15 1.562-3.624.555-3.357-1.366l5.217-37.56h23.096Z" />
        </svg>
    );
};
